import { render } from "./PerfilPagosEdit.vue?vue&type=template&id=1df0f8f4"
import script from "./PerfilPagosEdit.vue?vue&type=script&lang=ts"
export * from "./PerfilPagosEdit.vue?vue&type=script&lang=ts"
script.render = render

export default script